import type React from 'react';

import googleMapsLogo from '#src/assets/googleMaps/google-maps-logo.svg';

export const GoogleMapsAttribution: React.FC = () => (
	// eslint-disable-next-line @change-ds/ds-no-arbitrary-spacing-classname
	<div className="border-stroke-weaker flex justify-end border-t px-[15px] py-2.5">
		<a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer" tabIndex={-1}>
			<img src={googleMapsLogo} alt="Google Maps" className="h-[18px] w-auto" />
		</a>
	</div>
);
